import Index from "../index";
import request from "@/common/request";
import {
  ICommentsResponse,
  ITopicListRes,
  IHouseDetailRes,
  IJobDetailRes
} from "./types";
class IndexRequest extends Index {
  /**
   * 广场详情
   */
  squareDetail(params: {
    id: string;
    appId: string;
    sessionId: string;
    token: string;
    isOpenApp: string;
    vfrom: string;
  }): Promise<any> {
    return request.post(`/moments/detail/${params.id}.html`, {
      appId: params.appId,
      sessionId: params.sessionId,
      token: params.token,
      isOpenApp: params.isOpenApp,
      vfrom: params.vfrom
    });
  }

  comments(params: {
    appId: string;
    sourceId: string;
    sourceType: string | number;
    lastReplyId: string | number | undefined;
    lastCreateTime: string | number | undefined;
    sessionId: string | number;
    token: string | number;
  }): Promise<ICommentsResponse> {
    return request.post("/commments.html", params);
  }

  /**
   * 广场话题详情
   */
  squareShareDetail(params: {
    appId: string;
    id: string;
    token: string;
    sessionId: string;
    isOpenApp: string;
  }): Promise<any> {
    return request.post(
      `/moments/topicDetail/${params.appId}/${params.id}.html`,
      params
    );
  }
  /**
   * 话题 最热 最新列表
   */
  getMoments(params: {
    token: string;
    sessionId: string;
    appId: string;
    lastId: string;
    userId: string;
    topicId: string;
    lastBusinessValue: string;
    lastReplyCountValue: string;
    listType: string;
    search: string;
    isFengJie: string;
    categoryCode: string;
  }): Promise<ITopicListRes> {
    return request.post("/moments/getMoments.html", params);
  }

  /**
   * 房屋详情
   */
  getHouseDetail(id: string): Promise<IHouseDetailRes> {
    return request.post(`/building/detail/${id}.html`, {
      id: id
    });
  }
  /**
   * 工作详情
   */
  getJobDetail(appId: string, id: string): Promise<IJobDetailRes> {
    return request.post(`/recuitDetail.html`, {
      id: id,
      appId: appId
    });
  }
}

export default new IndexRequest();
